import { render, staticRenderFns } from "./ticketWeekly.vue?vue&type=template&id=00aced5b"
import script from "./ticketWeekly.vue?vue&type=script&lang=js"
export * from "./ticketWeekly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports